export default __webpack_public_path__ + "static/media/diners.143a8dc5.svg";